import { gql } from '@apollo/client';

export const GET_INVENTORIES = gql`
  query GetInventoryInspections($propertyId: ID!) {
    inventoryInspections(propertyId: $propertyId) {
      id
      type
      inspectionDate
      inspectorName
      receiverName
      generalNotes
      sections {
        id
        key
        title
        order
        isSystem
        items {
          id
          title
          quantity
          status
          notes
          order
          files {
            id
            url
          }
        }
      }
    }
  }
`;

